// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Auth Layout Styles */
.auth-layout {
  min-height: 100vh;
  display: flex;
  background-color: var(--bg-primary);
}

.auth-layout-left {
  flex: 0 0 30%;
  position: relative;
  overflow: hidden;
}

.auth-golf-image {
  width: 100%;
  height: 100vh;
  background: linear-gradient(
    135deg,
    #1a1a2e 0%,
    #16213e 25%,
    #0f3460 50%,
    #533483 75%,
    #e94560 100%
  );
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-golf-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(circle at 20% 80%, rgba(0, 255, 136, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(0, 255, 136, 0.05) 0%, transparent 50%),
    linear-gradient(45deg, transparent 30%, rgba(0, 255, 136, 0.02) 50%, transparent 70%);
  z-index: 1;
}

.auth-golf-overlay {
  position: relative;
  z-index: 2;
  text-align: center;
  color: var(--text-primary);
  padding: var(--spacing-2xl);
}

.auth-golf-content {
  max-width: 400px;
  margin: 0 auto;
}

.auth-golf-title {
  font-size: var(--font-size-4xl);
  font-weight: 800;
  color: var(--proskins-green);
  margin-bottom: var(--spacing-lg);
  text-shadow: 0 0 20px rgba(0, 255, 136, 0.3);
  line-height: 1.2;
}

.auth-golf-subtitle {
  font-size: var(--font-size-lg);
  color: var(--text-secondary);
  line-height: 1.6;
  font-weight: 300;
}

.auth-layout-right {
  flex: 0 0 70%;
  background-color: var(--bg-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-2xl);
}

.auth-form-container {
  width: 100%;
  max-width: 500px;
  background-color: var(--bg-card);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-xl);
  padding: var(--spacing-2xl);
  box-shadow: var(--shadow-lg);
}

.auth-form-header {
  text-align: center;
  margin-bottom: var(--spacing-2xl);
}

.auth-form-title {
  font-size: var(--font-size-3xl);
  font-weight: 700;
  color: var(--proskins-green);
  margin: var(--spacing-lg) 0 var(--spacing-sm) 0;
  text-align: center;
}

.auth-form-subtitle {
  font-size: var(--font-size-base);
  color: var(--text-secondary);
  text-align: center;
  margin: 0;
  line-height: 1.5;
}

.auth-form-content {
  width: 100%;
}

/* Form Styles */
.auth-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
}

.auth-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-md);
}

.auth-form-row-3 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: var(--spacing-md);
}

.auth-form-row-full {
  grid-column: 1 / -1;
}

.auth-form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: var(--spacing-md);
}

.auth-form-actions {
  display: flex;
  gap: var(--spacing-md);
  margin-top: var(--spacing-lg);
}

.auth-form-actions .proskins-btn {
  flex: 1 1;
}

.auth-divider {
  position: relative;
  text-align: center;
  margin: var(--spacing-xl) 0;
}

.auth-divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--border-primary);
}

.auth-divider span {
  background: var(--bg-card);
  padding: 0 var(--spacing-md);
  color: var(--text-muted);
  font-size: var(--font-size-sm);
  position: relative;
  z-index: 1;
}

.auth-link {
  color: var(--proskins-green);
  text-decoration: none;
  font-weight: 500;
  transition: color var(--transition-fast);
}

.auth-link:hover {
  color: var(--proskins-green-light);
  text-decoration: underline;
}

.auth-text {
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  text-align: center;
  margin: 0;
}

/* Password Input Container */
.auth-password-container {
  position: relative;
}

.auth-password-toggle {
  position: absolute;
  right: var(--spacing-md);
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  font-size: var(--font-size-lg);
  padding: var(--spacing-xs);
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
}

.auth-password-toggle:hover {
  color: var(--proskins-green);
  background-color: rgba(0, 255, 136, 0.1);
}

/* Upload Section */
.auth-upload-section {
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  padding: var(--spacing-lg);
  background-color: var(--bg-secondary);
  margin: var(--spacing-lg) 0;
}

.auth-upload-title {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: var(--spacing-sm);
}

.auth-upload-subtitle {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  margin-bottom: var(--spacing-lg);
}

.auth-upload-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-md);
}

.auth-upload-item {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.auth-upload-dropzone {
  border: 2px dashed var(--border-secondary);
  border-radius: var(--radius-md);
  padding: var(--spacing-lg);
  text-align: center;
  cursor: pointer;
  transition: all var(--transition-fast);
  background-color: var(--bg-input);
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-upload-dropzone:hover {
  border-color: var(--proskins-green);
  background-color: rgba(0, 255, 136, 0.05);
}

.auth-upload-dropzone-active {
  border-color: var(--proskins-green);
  background-color: rgba(0, 255, 136, 0.1);
}

.auth-upload-dropzone-error {
  border-color: var(--error);
  background-color: rgba(255, 68, 68, 0.05);
}

.auth-upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-sm);
}

.auth-upload-placeholder span {
  font-size: var(--font-size-2xl);
}

.auth-upload-placeholder p {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  font-weight: 500;
}

.auth-upload-placeholder small {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}

.auth-upload-file {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  width: 100%;
}

.auth-upload-file span {
  font-size: var(--font-size-lg);
  flex-shrink: 0;
}

.auth-upload-file div {
  flex: 1 1;
  text-align: left;
}

.auth-upload-file strong {
  display: block;
  font-size: var(--font-size-sm);
  color: var(--text-primary);
  margin-bottom: var(--spacing-xs);
}

.auth-upload-file p {
  margin: 0;
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
}

.auth-upload-error {
  font-size: var(--font-size-xs);
  color: var(--error);
  margin-top: var(--spacing-xs);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .auth-layout-left {
    flex: 0 0 25%;
  }
  
  .auth-layout-right {
    flex: 0 0 75%;
  }
}

@media (max-width: 768px) {
  .auth-layout {
    flex-direction: column;
  }
  
  .auth-layout-left {
    flex: 0 0 200px;
  }
  
  .auth-golf-image {
    height: 200px;
  }
  
  .auth-golf-title {
    font-size: var(--font-size-2xl);
  }
  
  .auth-golf-subtitle {
    font-size: var(--font-size-sm);
  }
  
  .auth-layout-right {
    flex: 1 1;
    padding: var(--spacing-lg);
  }
  
  .auth-form-container {
    padding: var(--spacing-lg);
  }
  
  .auth-form-row,
  .auth-form-row-3 {
    grid-template-columns: 1fr;
  }
  
  .auth-upload-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .auth-layout-right {
    padding: var(--spacing-md);
  }
  
  .auth-form-container {
    padding: var(--spacing-md);
    border-radius: var(--radius-lg);
  }
  
  .auth-form-title {
    font-size: var(--font-size-2xl);
  }
  
  .auth-form-actions {
    flex-direction: column;
  }
  
  .auth-form-actions .proskins-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/auth/AuthLayout.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb;;;;;;;GAOC;EACD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;yFAGuF;EACvF,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,uCAAuC;EACvC,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA,mBAAmB;AACnB;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,iCAAiC;EACjC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,SAAO;IACP,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Auth Layout Styles */\n.auth-layout {\n  min-height: 100vh;\n  display: flex;\n  background-color: var(--bg-primary);\n}\n\n.auth-layout-left {\n  flex: 0 0 30%;\n  position: relative;\n  overflow: hidden;\n}\n\n.auth-golf-image {\n  width: 100%;\n  height: 100vh;\n  background: linear-gradient(\n    135deg,\n    #1a1a2e 0%,\n    #16213e 25%,\n    #0f3460 50%,\n    #533483 75%,\n    #e94560 100%\n  );\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.auth-golf-image::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: \n    radial-gradient(circle at 20% 80%, rgba(0, 255, 136, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(0, 255, 136, 0.05) 0%, transparent 50%),\n    linear-gradient(45deg, transparent 30%, rgba(0, 255, 136, 0.02) 50%, transparent 70%);\n  z-index: 1;\n}\n\n.auth-golf-overlay {\n  position: relative;\n  z-index: 2;\n  text-align: center;\n  color: var(--text-primary);\n  padding: var(--spacing-2xl);\n}\n\n.auth-golf-content {\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n.auth-golf-title {\n  font-size: var(--font-size-4xl);\n  font-weight: 800;\n  color: var(--proskins-green);\n  margin-bottom: var(--spacing-lg);\n  text-shadow: 0 0 20px rgba(0, 255, 136, 0.3);\n  line-height: 1.2;\n}\n\n.auth-golf-subtitle {\n  font-size: var(--font-size-lg);\n  color: var(--text-secondary);\n  line-height: 1.6;\n  font-weight: 300;\n}\n\n.auth-layout-right {\n  flex: 0 0 70%;\n  background-color: var(--bg-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-2xl);\n}\n\n.auth-form-container {\n  width: 100%;\n  max-width: 500px;\n  background-color: var(--bg-card);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-xl);\n  padding: var(--spacing-2xl);\n  box-shadow: var(--shadow-lg);\n}\n\n.auth-form-header {\n  text-align: center;\n  margin-bottom: var(--spacing-2xl);\n}\n\n.auth-form-title {\n  font-size: var(--font-size-3xl);\n  font-weight: 700;\n  color: var(--proskins-green);\n  margin: var(--spacing-lg) 0 var(--spacing-sm) 0;\n  text-align: center;\n}\n\n.auth-form-subtitle {\n  font-size: var(--font-size-base);\n  color: var(--text-secondary);\n  text-align: center;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.auth-form-content {\n  width: 100%;\n}\n\n/* Form Styles */\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-lg);\n}\n\n.auth-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-md);\n}\n\n.auth-form-row-3 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: var(--spacing-md);\n}\n\n.auth-form-row-full {\n  grid-column: 1 / -1;\n}\n\n.auth-form-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: var(--spacing-md);\n}\n\n.auth-form-actions {\n  display: flex;\n  gap: var(--spacing-md);\n  margin-top: var(--spacing-lg);\n}\n\n.auth-form-actions .proskins-btn {\n  flex: 1;\n}\n\n.auth-divider {\n  position: relative;\n  text-align: center;\n  margin: var(--spacing-xl) 0;\n}\n\n.auth-divider::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: var(--border-primary);\n}\n\n.auth-divider span {\n  background: var(--bg-card);\n  padding: 0 var(--spacing-md);\n  color: var(--text-muted);\n  font-size: var(--font-size-sm);\n  position: relative;\n  z-index: 1;\n}\n\n.auth-link {\n  color: var(--proskins-green);\n  text-decoration: none;\n  font-weight: 500;\n  transition: color var(--transition-fast);\n}\n\n.auth-link:hover {\n  color: var(--proskins-green-light);\n  text-decoration: underline;\n}\n\n.auth-text {\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n  text-align: center;\n  margin: 0;\n}\n\n/* Password Input Container */\n.auth-password-container {\n  position: relative;\n}\n\n.auth-password-toggle {\n  position: absolute;\n  right: var(--spacing-md);\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  font-size: var(--font-size-lg);\n  padding: var(--spacing-xs);\n  border-radius: var(--radius-sm);\n  transition: all var(--transition-fast);\n}\n\n.auth-password-toggle:hover {\n  color: var(--proskins-green);\n  background-color: rgba(0, 255, 136, 0.1);\n}\n\n/* Upload Section */\n.auth-upload-section {\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  padding: var(--spacing-lg);\n  background-color: var(--bg-secondary);\n  margin: var(--spacing-lg) 0;\n}\n\n.auth-upload-title {\n  font-size: var(--font-size-lg);\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: var(--spacing-sm);\n}\n\n.auth-upload-subtitle {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  margin-bottom: var(--spacing-lg);\n}\n\n.auth-upload-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-md);\n}\n\n.auth-upload-item {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n.auth-upload-dropzone {\n  border: 2px dashed var(--border-secondary);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-lg);\n  text-align: center;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  background-color: var(--bg-input);\n  min-height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.auth-upload-dropzone:hover {\n  border-color: var(--proskins-green);\n  background-color: rgba(0, 255, 136, 0.05);\n}\n\n.auth-upload-dropzone-active {\n  border-color: var(--proskins-green);\n  background-color: rgba(0, 255, 136, 0.1);\n}\n\n.auth-upload-dropzone-error {\n  border-color: var(--error);\n  background-color: rgba(255, 68, 68, 0.05);\n}\n\n.auth-upload-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.auth-upload-placeholder span {\n  font-size: var(--font-size-2xl);\n}\n\n.auth-upload-placeholder p {\n  margin: 0;\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.auth-upload-placeholder small {\n  font-size: var(--font-size-xs);\n  color: var(--text-muted);\n}\n\n.auth-upload-file {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  width: 100%;\n}\n\n.auth-upload-file span {\n  font-size: var(--font-size-lg);\n  flex-shrink: 0;\n}\n\n.auth-upload-file div {\n  flex: 1;\n  text-align: left;\n}\n\n.auth-upload-file strong {\n  display: block;\n  font-size: var(--font-size-sm);\n  color: var(--text-primary);\n  margin-bottom: var(--spacing-xs);\n}\n\n.auth-upload-file p {\n  margin: 0;\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n}\n\n.auth-upload-error {\n  font-size: var(--font-size-xs);\n  color: var(--error);\n  margin-top: var(--spacing-xs);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .auth-layout-left {\n    flex: 0 0 25%;\n  }\n  \n  .auth-layout-right {\n    flex: 0 0 75%;\n  }\n}\n\n@media (max-width: 768px) {\n  .auth-layout {\n    flex-direction: column;\n  }\n  \n  .auth-layout-left {\n    flex: 0 0 200px;\n  }\n  \n  .auth-golf-image {\n    height: 200px;\n  }\n  \n  .auth-golf-title {\n    font-size: var(--font-size-2xl);\n  }\n  \n  .auth-golf-subtitle {\n    font-size: var(--font-size-sm);\n  }\n  \n  .auth-layout-right {\n    flex: 1;\n    padding: var(--spacing-lg);\n  }\n  \n  .auth-form-container {\n    padding: var(--spacing-lg);\n  }\n  \n  .auth-form-row,\n  .auth-form-row-3 {\n    grid-template-columns: 1fr;\n  }\n  \n  .auth-upload-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .auth-layout-right {\n    padding: var(--spacing-md);\n  }\n  \n  .auth-form-container {\n    padding: var(--spacing-md);\n    border-radius: var(--radius-lg);\n  }\n  \n  .auth-form-title {\n    font-size: var(--font-size-2xl);\n  }\n  \n  .auth-form-actions {\n    flex-direction: column;\n  }\n  \n  .auth-form-actions .proskins-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
